module.exports = __webpack_public_path__ + "assets/dashboard_light.jpg";